export const AUTH_SERVICE_URL = `${process.env.REACT_APP_AUTH_SERVICE_URI}`;
export const API_URI = `${process.env.REACT_APP_DOMAIN_URI}/`;
export const MAIN_URL = `${process.env.REACT_APP_URI}`;
